import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// E6.1 — stato dell'interruttore delle funzioni Excel/Registro/Misure/SAL (scritture)
export const FUNZ = { attive: false, motivo: null, caricato: false };
export const useFunzioniExcel = () => {
  const [st, setSt] = useState({ ...FUNZ });
  useEffect(() => {
    const m = window.location.pathname.match(/\/cantieri\/([0-9a-f-]{36})/i);
    api.get("/funzioni-excel/stato", { params: m ? { cantiere_id: m[1] } : {} }).then((r) => {
      Object.assign(FUNZ, { attive: r.data.scrittura_attiva, motivo: r.data.motivo, caricato: true });
      setSt({ ...FUNZ });
    }).catch(() => {});
  }, []);
  return st;
};

export const FunzioniSpente = ({ st }) => (st.caricato && !st.attive ? (
  <p className="rounded-md border border-amber-300 bg-amber-50 p-2 text-xs text-amber-800" data-testid="funzioni-spente">
    Sola consultazione: {st.motivo}
  </p>
) : null);

export const STATO_SAL = {
  BOZZA: { label: "Bozza", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  VERIFICATO: { label: "Verificato", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  EMESSO: { label: "Emesso", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  LIQUIDATO: { label: "Liquidato", cls: "bg-violet-50 text-violet-800 border-violet-200" },
  ANNULLATO: { label: "Annullato", cls: "bg-rose-50 text-rose-700 border-rose-200 line-through" },
};

export const PREZZO_LABEL = {
  COMPUTO: "Prezzo del computo", CONTRATTO: "Prezzo concordato", MANUALE: "Prezzo manuale",
  DA_RISOLVERE: "Prezzo da risolvere", RIF_SAL: "Prezzo del SAL di riferimento",
};

export const DETR_LABEL = {
  RECUPERO_ANTICIPAZIONE: "Recupero anticipazione", RITENUTA_GARANZIA: "Ritenuta a garanzia",
  RITENUTA_INFORTUNI: "Ritenuta 0,5% infortuni", ALTRA: "Altra detrazione",
};

export const AZIONE_SAL = {
  CONTRATTO_CREATO: "Rapporto creato", CONTRATTO_MODIFICATO: "Condizioni modificate", SAL_CREATO: "Documento creato",
  SAL_RICALCOLATO: "Ricalcolato", SAL_VERIFICA: "Verificato", SAL_BOZZA: "Riportato in bozza", SAL_EMETTI: "Emesso",
  SAL_LIQUIDA: "Liquidato", SAL_ANNULLA: "Annullato", RIGA_PREZZO: "Prezzo risolto", RIGA_ESCLUDI: "Lavorazione esclusa",
  RIGA_INCLUDI: "Lavorazione reinclusa", RECUPERO_MANUALE: "Recupero rettificato", RECUPERO_AUTOMATICO: "Recupero automatico",
  DETRAZIONE_AGGIUNTA: "Detrazione aggiunta", DETRAZIONE_ELIMINATA: "Detrazione eliminata", RETTIFICA_AGGIUNTA: "Rettifica aggiunta",
  RETTIFICA_ELIMINATA: "Rettifica eliminata", PAGAMENTO: "Pagamento registrato", PAGAMENTO_ANNULLATO: "Pagamento annullato",
};

export const isAdmin = (u) => FUNZ.attive && !!u && u.role === "ADMIN";
export const canEditSal = (u) => FUNZ.attive && !!u && (u.role === "ADMIN" || u.role === "TECNICO");

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Operazione non riuscita";
};

export const run = async (fn, ok) => {
  try { const r = await fn(); if (ok) toast.success(ok); return r; } catch (e) { toast.error(errMsg(e)); return null; }
};

export const scarica = async (sid, ext) => {
  const r = await run(() => api.get(`/sal-e5/${sid}/export.${ext}`, { responseType: "blob" }));
  if (!r) return;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = (r.headers["content-disposition"] || "").split("filename=")[1] || `SAL.${ext}`;
  a.click();
  URL.revokeObjectURL(url);
};
